/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a

import type { ConcreteRequest } from 'relay-runtime';
export type CollabDraftQuery$variables = {
  draftShareId?: string | null;
  hydrateAdf?: boolean | null;
  id: string;
};
export type CollabDraftQuery$data = {
  readonly collabDraft: {
    readonly document: string | null;
    readonly metadata: {
      readonly title: string | null;
    } | null;
    readonly version: number | null;
  } | null;
};
export type CollabDraftQuery = {
  response: CollabDraftQuery$data;
  variables: CollabDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "draftShareId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hydrateAdf"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "draftShareId",
        "variableName": "draftShareId"
      },
      {
        "kind": "Variable",
        "name": "hydrateAdf",
        "variableName": "hydrateAdf"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CollabDraft",
    "kind": "LinkedField",
    "name": "collabDraft",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "document"
      },
      {
        "kind": "ScalarField",
        "name": "version"
      },
      {
        "concreteType": "CollabDraftMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "title"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CollabDraftQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CollabDraftQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
    "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
    "metadata": {},
    "name": "CollabDraftQuery",
    "operationKind": "query",
    "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
  }
};
})();

(node as any).hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";

export default node;
